import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-right\">\n    <defs>\n        <style type=\"text/css\"></style>\n    </defs>\n    <path d=\"M220.553846 157.538462L330.830769 39.384615l441.107693 417.476923c31.507692 31.507692 31.507692 86.646154 0 118.153847l-441.107693 417.476923-110.276923-110.276923 385.969231-362.338462L220.553846 157.538462z\" p-id=\"2048\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol